import { render, staticRenderFns } from "./AssignWindowsToOrder.vue?vue&type=template&id=0b01fc52"
import script from "./AssignWindowsToOrder.vue?vue&type=script&lang=js"
export * from "./AssignWindowsToOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports